export interface VoterCountable {
  respondent_name?: string | null;
  response_data?: Record<string, any> | null;
}

// Dédup unique pour Voting et Results. Le nom du votant est posé dans
// `response_data.voterName` au moment du vote ; la colonne SQL `respondent_name`
// est historiquement non renseignée côté écriture — s'y fier seul a déjà causé
// l'écart "1 votant" affiché alors que 3 répondants distincts existaient.
export function resolveVoterName(
  vote: VoterCountable,
  anonymousLabel = "Anonyme",
): string {
  const raw = vote.response_data?.voterName;
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (trimmed && trimmed !== "NO_NAME") return trimmed;
  }
  if (vote.respondent_name && vote.respondent_name.trim()) {
    return vote.respondent_name.trim();
  }
  return anonymousLabel;
}

export function countUniqueVoters(votes: VoterCountable[]): number {
  if (!votes || votes.length === 0) return 0;
  const names = new Set<string>();
  for (const v of votes) names.add(resolveVoterName(v));
  return names.size;
}
